import React from "react"

import ActionButton from "./ActionButton"
import style from "./index.module.sass"
import { RequestRejectOrder } from "../../apis/OrdersAPI";

// ----------------------------------------------------------------------------

function Actions(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { actions } = props.order;
  const orderId = props.order.id;

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  async function handleAction(name) {
    switch (name) {
      case "reject_request":

        RequestRejectOrder(orderId)
          .then((result) => {
              window.location.reload()
            },
            (error) => {
              alert("Impossibile effettuare l'azione")
            });

        break;
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  if (!actions) return null;

  return (
    <div className={style.container}>
      {actions.map(action => <ActionButton key={action.name}
                                           orderId={orderId}
                                           handleAction={handleAction}
                                           action={action}/>)}
    </div>
  )
}

// ----------------------------------------------------------------------------

export default Actions
